jQuery(function($) {

    var delayTimer;

    function sendRequest() {
        var filter = $('#filter');
        $('#loading').show();
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            dataType: 'json', // Set the expected response data type
            success: function(response) {
                $('#response').html(response.result);

                //filterTuotekategoriat(response.tuotekategoriat);

            },
            complete: function() {
                // Hide the loading GIF image after the request is complete
                $('#loading').hide();
            }
        });
    }

    sendRequest();

    $('#filter .artikkelit-select').on('change', function() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(sendRequest, 500);
    });



});

